export const reducerStatus = {
  loading: 'loading',
  succeeded: 'succeeded',
  failed: 'failed',
}
